import { FinanceType } from '../legos/constants';
import {
  CashOfferData,
  LeaseOfferData,
  OfferData,
  PurchaseOfferData,
} from '../legos/deskingTypes';
import {
  CashOffer,
  FullCashOffer,
  FullLeaseOffer,
  FullOffer,
  FullPurchaseOffer,
  LeaseOffer,
  Offer,
  PurchaseOffer,
} from '../legos/paymentTypes';
import { isDefined } from '../legos/utils/tsutils';

export const isPurchaseOfferData = (
  deskingOfferData: OfferData | null | undefined,
): deskingOfferData is PurchaseOfferData => {
  return deskingOfferData?.financeType === FinanceType.PURCHASE;
};

export const isLeaseOfferData = (
  deskingOfferData: OfferData | null | undefined,
): deskingOfferData is LeaseOfferData => {
  return deskingOfferData?.financeType === FinanceType.LEASE;
};

export const isCashOfferData = (
  deskingOfferData: OfferData | null | undefined,
): deskingOfferData is CashOfferData => {
  return deskingOfferData?.financeType === FinanceType.CASH;
};

export const isPurchaseOffer = (
  selectedOffer: Offer | FullOffer | null | undefined,
): selectedOffer is PurchaseOffer => {
  return (
    isDefined(selectedOffer) &&
    Object.prototype.hasOwnProperty.call(selectedOffer, 'apr')
  );
};

export const isLeaseOffer = (
  selectedOffer: Offer | FullOffer | null | undefined,
): selectedOffer is LeaseOffer => {
  return (
    isDefined(selectedOffer) &&
    Object.prototype.hasOwnProperty.call(selectedOffer, 'mileage')
  );
};

export const isCashOffer = (
  selectedOffer: Offer | FullOffer | null | undefined,
): selectedOffer is CashOffer => {
  return (
    isDefined(selectedOffer) &&
    !isPurchaseOffer(selectedOffer) &&
    !isLeaseOffer(selectedOffer)
  );
};

export const isFullPurchaseOffer = (
  selectedOffer: Offer | FullOffer | null | undefined,
): selectedOffer is FullPurchaseOffer => {
  return (
    isDefined(selectedOffer) &&
    Object.prototype.hasOwnProperty.call(selectedOffer, 'financeAmount')
  );
};

export const isFullLeaseOffer = (
  selectedOffer: Offer | FullOffer | null | undefined,
): selectedOffer is FullLeaseOffer => {
  return (
    isDefined(selectedOffer) &&
    Object.prototype.hasOwnProperty.call(selectedOffer, 'residual')
  );
};

export const isFullCashOffer = (
  selectedOffer: Offer | FullOffer | null | undefined,
): selectedOffer is FullCashOffer => {
  return (
    isDefined(selectedOffer) &&
    Object.prototype.hasOwnProperty.call(selectedOffer, 'totalDue') &&
    Object.prototype.hasOwnProperty.call(selectedOffer, 'balance')
  );
};
